// extracted by mini-css-extract-plugin
export default {"CardContainer":"Menu_CardContainer__ZD8Tm","Menucontent":"Menu_Menucontent__ZoO0i","MenuContainer":"Menu_MenuContainer__QBZ7U"};